import domWrap from "../utils/domWrap";
import h from "../utils/htm";
import offCanvas from "../utils/offCanvas";

export default async blogCategoryFilter => { 
	// Page Selector
	[...document.querySelectorAll('select[page-query]')].forEach(select => {
		select.addEventListener('change',() => {
			window.location.href = '?' + select.getAttribute('name') + '=' + select.value;
		});
	});
}